<template>
  <div class="text-center">
    <v-snackbar
      v-model="isactive"
      :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="isactive = false">
          关闭
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    data: () => ({
      timeout: 2000,
    }),
    props:{
      text:{
        type:String,
      },
      isactive:{
        type:Boolean,
        default:false,
      }
    }
  }
</script>